import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ClientLayout from '../../layouts/ClientLayout';

const Cart = () => {
  // Données du panier
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      image: "/images/product4.jpg",
      name: "Chaise d'intérieur Space Gray (9th Generation)",
      price: 120500,
      quantity: 2,
      total: 241000
    },
    {
      id: 2,
      image: "/images/product4.jpg",
      name: "Chaise d'intérieur Space Gray (9th Generation)",
      price: 120500,
      quantity: 2,
      total: 241000
    }
  ]);

  const [couponCode, setCouponCode] = useState('');
  const shippingAddress = "Villa Le Colombier 289, rue Wezu Angle rue Bekpo Lomé (Tokoin Hôpital) - Togo.";

  // Calculs
  const subtotal = cartItems.reduce((sum, item) => sum + item.total, 0);
  const shippingCost = 10500;
  const total = subtotal + shippingCost;

  const updateQuantity = (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    
    setCartItems(cartItems.map(item => 
      item.id === itemId 
        ? { ...item, quantity: newQuantity, total: item.price * newQuantity }
        : item
    ));
  };

  const removeItem = (itemId) => {
    setCartItems(cartItems.filter(item => item.id !== itemId));
  };

  const applyCoupon = () => {
    // Logique pour appliquer le coupon
    console.log('Coupon appliqué:', couponCode);
  };

  return (
    <ClientLayout>
      <div className="flex-1 md:mx-8 lg:mx-16 mx-auto py-8">
        {/* Fil d'Ariane */}
        <div className="mb-8">
          <nav className="text-sm text-gray-600">
            <Link to="/" className="hover:text-gray-900">Accueil</Link>
            <span className="mx-2">&gt;</span>
            <span className="text-gray-900">Panier</span>
          </nav>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Section Produits - 2/3 de la largeur */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg">
              {/* Tableau des produits */}
              <table className="w-full">
                {/* En-tête du tableau */}
                <thead>
                  <tr className="bg-gray- ">
                    <th className="text-left p-4 pl-0 text-sm font-medium text-gray-700">Produit</th>
                    <th className="text-center p-4 pl-0 text-sm font-medium text-gray-700">Prix</th>
                    <th className="text-center p-4 pl-0 text-sm font-medium text-gray-700">Quantité</th>
                    <th className="text-center p-4 pl-0 text-sm font-medium text-gray-700">Total</th>
                    <th className="text-center p-4 pl-0 text-sm font-medium text-gray-700">Action</th>
                  </tr>
                </thead>

                {/* Corps du tableau */}
                <tbody className="divide-y">
                  {cartItems.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      {/* Colonne Produit */}
                      <td className="p-4 pl-0">
                        <div className="flex items-center">
                          <img
                            src={item.image}
                            alt={item.name}
                            className="w-16 h-16 object-cover rounded-lg mr-4"
                            onError={(e) => {
                              e.target.src = "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=765&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
                            }}
                          />
                          <div className="flex-1">
                            <h3 className="font-semibold text-gray-900 text-sm md:text-base">
                              {item.name}
                            </h3>
                          </div>
                        </div>
                      </td>

                      {/* Colonne Prix */}
                      <td className="p-4 text-center">
                        <span className="text-gray-900 font-medium whitespace-nowrap">
                          {item.price.toLocaleString()} Fcfa
                        </span>
                      </td>

                      {/* Colonne Quantité */}
                      <td className="p-4 text-center">
                        <div className="flex items-center justify-center">
                          <div className="flex items-center border border-gray-500 rounded-full">
                            <button
                              onClick={() => updateQuantity(item.id, item.quantity - 1)}
                              className="px-3 py-1 text-gray-600 text-xl hover:text-gray-900 rounded-l-lg"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minus-icon lucide-minus"><path d="M5 12h14"/></svg>
                            </button>
                            <input
                              type="number"
                              value={item.quantity}
                              onChange={(e) => updateQuantity(item.id, parseInt(e.target.value) || 1)}
                              className="w-12 text-center border-none focus:ring-0 text-sm bg-transparent focus:outline-none"
                              min="1"
                            />
                            <button
                              onClick={() => updateQuantity(item.id, item.quantity + 1)}
                              className="px-3 py-1 text-gray-600 text-xl hover:text-gray-900 rounded-r-lg"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
                            </button>
                          </div>
                        </div>
                      </td>

                      {/* Colonne Total */}
                      <td className="p-4 text-center">
                        <span className="text-gray-900 font-medium whitespace-nowrap">
                          {item.total.toLocaleString()} Fcfa
                        </span>
                      </td>

                      {/* Colonne Action */}
                      <td className="p-4 text-center">
                        <button
                          onClick={() => removeItem(item.id)}
                          className="text-red-500 hover:text-red-700 p-2 rounded-full bg-red-50 hover:bg-red-100 border border-red-500"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Section Coupon */}
              <div className="p-6 border-t rounded-b-lg w-full lg:w-2/3">
                <div className="flex gap-4 items-center">
                    <h2 className="text-base font-medium text-gray-900">Coupon</h2>
                  <input
                    type="text"
                    placeholder="Entrez le code de réduction"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                    className="w-full  flex-1 px-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-orange-light focus:border-transparent"
                  />
                  <button
                    onClick={applyCoupon}
                    className="whitespace-nowrap px-6 py-2 bg-gray-900 text-gray-200 rounded-full hover:bg-gray-800 transition-colors"
                  >
                    Appliquer le code
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Section Totaux - 1/3 de la largeur */}
          <div className="lg:col-span-1">
            <div className="bg-gray-50 rounded-lg p-6 sticky top-8">
              <h2 className="text-lg font-bold text-gray-900 mb-6">TOTAUX DU PANIER</h2>
              
              {/* Détails des coûts */}
              <div className="space-y-4 mb-6">
                <div className="flex justify-between border-b border-gray-300 pb-4">
                  <span className="text-gray-400">Total produit</span>
                  <span className="font-medium">{subtotal.toLocaleString()} Fcfa</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Frais d'expédition</span>
                  <span className="font-medium">{shippingCost.toLocaleString()} Fcfa</span>
                </div>
              </div>

              {/* Adresse de livraison */}
              <div className="mb-6 p-4 rounded-lg text-right">
                <h3 className="font-medium text-gray-900 mb-2">Adresse de livraison</h3>
                <p className="text-sm text-gray-600 mb-2">
                  Expédition vers {shippingAddress}
                </p>
                <button className="text-orange-hover text-sm hover:text-orange-700 underline text-right">
                  Changer d'adresse
                </button>
              </div>

              {/* Total final */}
              <div className="border-t pt-4 mb-6">
                <div className="flex justify-between items-center">
                  <span className="text-base text-gray-400">Total</span>
                  <span className="text-lg font-bold text-gray-900">{total.toLocaleString()} Fcfa</span>
                </div>
              </div>

              {/* Bouton passer à la caisse */}
              <Link to="/checkout">
                <button className="w-full bg-orange-hover text-white py-3 px-6 rounded-full hover:bg-orange-700 transition-colors">
                  Passer à la caisse
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default Cart; 